"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PbsCookieNames = void 0;
let PbsCookieNames = exports.PbsCookieNames = /*#__PURE__*/function (PbsCookieNames) {
  PbsCookieNames["ECREF_OWNER"] = "ecref_owner";
  PbsCookieNames["ECREF"] = "ecref";
  /**
   * This cookie is only available when user is logged in and PBS is active (PBS_OWNER should be defined as well)
   */
  PbsCookieNames["PBS_CODE"] = "pbs_code";
  /**
   * This cookie will be available even on anonymous user and controls if PBS should be visible
   */
  PbsCookieNames["PBS_OWNER"] = "pbs_owner";
  PbsCookieNames["PPL_CODE"] = "ppl_code";
  return PbsCookieNames;
}({});
